import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { ExtraModal, RightModal, RightModalFade } from './modals';
import { MiniModal } from './miniModals';
import { Message } from './message';
import { ResetedLink } from '../modules/auth/components/reseted';
import { NavbarLink } from './navbar/Navbar';
import { NavbarMobileLink } from './navbar/NavbarMobile';
import { Route, useNavigate } from 'react-router';
import _ from 'underscore';
import { Routes, useSearchParams } from 'react-router-dom';
import { ShopLink } from 'app/modules/shop';
import { LendingLink } from 'app/modules/lending';
import { Context } from '../index';
import { useDesktop } from '../hooks/useDesktop';
import { ConnectedFooter } from './footer/footer';
import { SelectPointLink } from 'app/modules/points';
import { fetchUser } from '../modules/auth/actions/postGetUser';
import { getToken } from '../functions/request';
import { ShopModalLink } from 'app/modules/shop/components/shopModal';
import { ConnectedSnapshotAlert } from '../modules/setting/components/lending/alert';
import { useGetActiveTypesQuery } from '../api';
import { useFavicon } from 'app/hooks/useFavicon';
import { fetchShopTypes } from 'app/modules/shop/actions/getTypes';

function useResetPassword(dispatch) {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    useEffect(() => {
        const token = params.get('token');
        if (token) {
            dispatch({
                type: 'openMiniModal',
                header: 'Смена пароля',
                children: (
                    <ResetedLink
                        token={token}
                        onValid={() => {
                            navigate('/');
                        }}
                    />
                ),
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        }
    }, []);
}

const App = ({
    dispatch,
    setting,
    order,
    extraModals,
    modals,
    miniModals,
    message,
    delMessage,
    point,
}) => {
    const refContent = useRef();
    const { contentWrapper, contentContainer } = useContext(Context);
    useResetPassword(dispatch);
    useFavicon();
    useEffect(() => {
        const token = getToken();
        if (token) dispatch(fetchUser());
    }, []);
    useGetActiveTypesQuery({ point: point?.id }, { skip: !point?.id });
    const isDesktop = useDesktop();
    useEffect(() => {
        if (point?.id) {
            dispatch(fetchShopTypes(point.id));
        }
    }, [point?.id]);
    return (
        <>
            <div
                style={{
                    background: setting.content.primary.background,
                }}
                className="content-container"
                ref={contentContainer}
            >
                <SelectPointLink />
                <div className={'content-wrapper'} ref={contentWrapper}>
                    {!order.point || !order.point.id ? (
                        <>
                            <NavbarLink />
                            {isDesktop ? null : <NavbarMobileLink />}
                        </>
                    ) : (
                        <>
                            <ConnectedSnapshotAlert />
                            <NavbarLink refContent={refContent} />
                            <div
                                className={
                                    'content' +
                                    (!setting.content.navbar.logo
                                        ? ' pt-3'
                                        : '')
                                }
                                ref={refContent}
                            >
                                <Routes>
                                    <Route
                                        path="/*"
                                        index
                                        element={<LendingLink />}
                                    />
                                    <Route
                                        path={'categories/:categoryID'}
                                        element={<ShopLink />}
                                    />
                                    <Route
                                        path={
                                            'categories/:categoryID/products/:productID'
                                        }
                                        element={<ShopLink />}
                                    />
                                    {_.map(
                                        setting.content.pages,
                                        (page, key) => {
                                            return (
                                                <Route
                                                    key={key}
                                                    path={page.title}
                                                    element={
                                                        <div
                                                            dangerouslySetInnerHTML={{
                                                                __html: page.content,
                                                            }}
                                                        />
                                                    }
                                                />
                                            );
                                        }
                                    )}
                                </Routes>
                                <div
                                    className="custom-footer-html"
                                    dangerouslySetInnerHTML={{
                                        __html: setting.content.primary.footer,
                                    }}
                                />
                                {isDesktop ? null : (
                                    <NavbarMobileLink
                                        className="invisible"
                                        refContent={refContent}
                                    />
                                )}
                            </div>

                            {isDesktop ? null : (
                                <NavbarMobileLink refContent={refContent} />
                            )}
                            {
                                //Cообщения об ошибках
                                message.isOpen ? (
                                    <Message
                                        delMessage={delMessage}
                                        error={message.type === 'error'}
                                    >
                                        {message.text}
                                    </Message>
                                ) : null
                            }

                            {/*Модульные окна*/}
                            <ShopModalLink />
                            <ExtraModal
                                IsOpen={extraModals.isOpen}
                                onClose={extraModals.onClose}
                                HeadItem={extraModals.HeadItem}
                                FooterItem={extraModals.FooterItem}
                            >
                                {extraModals.children}
                            </ExtraModal>

                            {/*Правое модульное окно*/}
                            <RightModalFade
                                IsOpen={modals.isOpen}
                                isNoBackground={modals.isNoBackground}
                                onClose={modals.onClose}
                            />
                            <RightModal
                                IsOpen={modals.isOpen}
                                onClose={modals.onClose}
                                HeadItem={modals.HeadItem}
                                FooterItem={modals.FooterItem}
                                setting={setting}
                            >
                                {modals.children}
                            </RightModal>

                            <MiniModal
                                IsOpen={miniModals.isOpen}
                                options={miniModals.options}
                                header={miniModals.header}
                                onClose={miniModals.onClose}
                            >
                                {miniModals.children}
                            </MiniModal>
                        </>
                    )}
                </div>
                <ConnectedFooter />
            </div>
        </>
    );
};

App.propTypes = {
    content: PropTypes.node,
};

export { App };
